(function(){
  var HEX={bege:'#e4c9a8',preto:'#2b2b2b',black:'#2b2b2b',rosa:'#e690a8',pink:'#e690a8',marrom:'#835444',brown:'#835444','lilás':'#b9a4cc',lilas:'#b9a4cc',roxo:'#b9a4cc',cherry:'#a8243a',vinho:'#a8243a','bordô':'#a8243a',bordo:'#a8243a',azul:'#3e6e9e',branco:'#f2efe9',white:'#f2efe9','azul claro':'#9cc2e0',amarelo:'#f0c13f',yellow:'#f0c13f',laranja:'#e6823a',orange:'#e6823a',verde:'#6e7f66',green:'#6e7f66',cinza:'#9a9a9a',gray:'#9a9a9a',nude:'#dcab86',caramelo:'#dcab86','off white':'#f2efe9'};
  function hex(n){ n=(n||'').toString().toLowerCase().trim(); return HEX[n]||HEX[n.split(/[\s(]+/)[0]]||'#cfcfcf'; }
  function money(c){ return 'R$ '+(c/100).toFixed(2).replace('.',','); }
  function el(tag,cls,html){ var e=document.createElement(tag); if(cls)e.className=cls; if(html!=null)e.innerHTML=html; return e; }
  function hasAvail(c){ return (c.products||[]).some(function(p){return p.available;}); }

  function init(root){
    if(root.dataset.kitInit)return; root.dataset.kitInit='1'; // evita init duplicado
    var data; try{ data=JSON.parse(root.querySelector('.kit__data').textContent); }catch(e){ return; }
    var cats=data.cats||[];
    var CODE=(data.code||'').toString().trim();
    var AUTO=!!data.autoApply; // false = cliente digita o cupom no checkout (Configurações do tema)
    var COUPON_NOTE=(data.couponNote||'').toString();
    var D2=parseFloat(data.disc2)||0, D3=parseFloat(data.disc3)||0, D4=parseFloat(data.disc4)||0;
    var CHOICE=Math.max(0,parseInt(data.choiceSteps,10)||0);
    var CHOICE_LABEL=data.choiceLabel||'Escolha um produto';
    var CHOICE_INSTR=data.choiceInstruction||'';
    var ADDMORE=(data.addmoreLabel==null?'Adicionar mais um item':String(data.addmoreLabel));
    var ALLOW_MORE=!!ADDMORE.trim(); // rótulo vazio = desativa "adicionar mais"
    var MIN=Math.max(1,parseInt(data.minItems,10)||1);

    var requiredCats=[], allCats=[];
    cats.forEach(function(c,i){ if(c.required) requiredCats.push({cat:c,idx:i}); if(hasAvail(c)) allCats.push({cat:c,idx:i}); });

    // STEPS guiadas: obrigatórias (coleção fixa) + N etapas "escolha qualquer produto"
    // etapa "escolha" é OBRIGATÓRIA só até bater o mínimo (MIN); as demais são opcionais.
    var needChoice=Math.max(0, MIN - requiredCats.length); // qtas etapas de escolha contam p/ o mínimo
    var STEPS=requiredCats.map(function(o){ return {type:'fixed',cat:o.cat,idx:o.idx,label:o.cat.label,optional:false}; });
    for(var s=0;s<CHOICE;s++){ STEPS.push({type:'any',label:CHOICE_LABEL,num:requiredCats.length+s+1,optional:(s>=needChoice)}); }
    var N=STEPS.length; // step N = resumo/done ; step N+1 = "adicionar mais" (transitório)

    var sel={}, cache={}, uid=0, step=0, maxReached=0, anySel=0, extraOpened=false;

    var progress=root.querySelector('.kit__progress');
    var stage=root.querySelector('.kit__stage');
    var back=root.querySelector('.kit__back');
    var skip=root.querySelector('.kit__skip');
    var cartItems=root.querySelector('.kit__items');
    var cartTotals=root.querySelector('.kit__totals');
    // copiar o cupom com 1 toque (delegado: o innerHTML do totals re-renderiza)
    cartTotals.addEventListener('click',function(ev){
      var b=ev.target.closest('.kit__copy'); if(!b)return;
      var code=b.getAttribute('data-code')||'';
      var done=function(){ var t=b.innerHTML; b.classList.add('is-copied'); b.childNodes[0].textContent='Copiado ✓'; setTimeout(function(){ b.classList.remove('is-copied'); b.childNodes[0].textContent=code; },1600); };
      if(navigator.clipboard&&navigator.clipboard.writeText){ navigator.clipboard.writeText(code).then(done,done); }
      else{ var ta=document.createElement('textarea'); ta.value=code; document.body.appendChild(ta); ta.select(); try{document.execCommand('copy');}catch(e){} ta.remove(); done(); }
    });
    var cartUpsell=root.querySelector('.kit__upsell');
    var cartHint=root.querySelector('.kit__hint');
    var addBtn=root.querySelector('.kit__add');
    var barEl=root.querySelector('.kit__bar');
    // move a barra pro <body> p/ que position:fixed cole na viewport
    // (ancestrais com transform/filter no tema quebram o fixed)
    if(barEl){ document.body.appendChild(barEl); }
    var barTotal=barEl?barEl.querySelector('.kit__bar-total'):null;
    var barSub=barEl?barEl.querySelector('.kit__bar-sub'):null;
    var barBtn=barEl?barEl.querySelector('.kit__bar-btn'):null;
    var finishBtn=root.querySelector('.kit__finish');
    root.querySelector('.kit__cart h3').textContent=data.cartTitle||'Seu kit';
    function canFinish(){ return requiredMissing().length===0 && Object.keys(sel).length>=MIN; }

    function totalItems(){ return Object.keys(sel).length; }
    function catCount(ci){ return Object.keys(sel).filter(function(k){return sel[k].cat===ci;}).length; }
    function subtotal(){ var s=0; Object.keys(sel).forEach(function(k){s+=sel[k].price;}); return s; }
    function discPct(n){ if(n>=4)return D4; if(n===3)return D3; if(n===2)return D2; return 0; }
    function requiredMissing(){ var m=[]; requiredCats.forEach(function(o){ if(catCount(o.idx)===0)m.push(o.cat.label); }); return m; }
    function firstAvailableIdx(){ for(var i=0;i<STEPS.length;i++){ /*noop*/ } return 0; }

    // primeira coleção do browse "any": a 1ª (ex.: Sandália) — abrir direto numa categoria
    // não-obrigatória (Meias) fazia o cliente achar que a meia era obrigatória.
    anySel=0;

    back.addEventListener('click',function(){ if(step===N+1) goto(N); else goto(step-1); });
    skip.addEventListener('click',function(){ goto(step+1); });
    addBtn.addEventListener('click',addToCart);
    if(barBtn) barBtn.addEventListener('click',function(){ if(!barBtn.disabled) addToCart(); else { var c=root.querySelector('.kit__cart'); if(c)c.scrollIntoView({behavior:'smooth',block:'center'}); } });
    if(finishBtn) finishBtn.addEventListener('click',function(){ if(canFinish()) addToCart(); });

    function goto(i){ var maxi=ALLOW_MORE?N+1:N; if(i<0||i>maxi)return; step=i; if(step<=N&&step>maxReached)maxReached=step; render();
      try{ root.scrollIntoView({behavior:'smooth',block:'start'}); }catch(e){} }

    function renderProgress(){
      progress.innerHTML='';
      STEPS.forEach(function(s,i){
        var done = i<step || (s.type==='fixed'? catCount(s.idx)>0 : false) || (step>N);
        var p=el('div','kit__pstep'+(i===step?' is-active':'')+(done?' is-done':'')+(i<=maxReached?' is-clickable':''));
        p.appendChild(el('div','kit__pnum', done?'✓':String(i+1)));
        p.appendChild(el('div','kit__plabel', s.type==='fixed'?s.cat.label:(s.label+' '+s.num)));
        if(i<=maxReached){ p.addEventListener('click',function(){ goto(i); }); }
        progress.appendChild(p);
      });
      // nó extra "Mais itens" — só aparece quando o cliente opta por adicionar mais
      if(ALLOW_MORE && extraOpened){
        var active = step===N+1;
        var pe=el('div','kit__pstep is-clickable'+(active?' is-active':''));
        pe.appendChild(el('div','kit__pnum', active?String(STEPS.length+1):'＋'));
        pe.appendChild(el('div','kit__plabel','Mais itens'));
        pe.addEventListener('click',function(){ extraOpened=true; goto(N+1); });
        progress.appendChild(pe);
      }
    }

    function renderNav(){
      back.disabled = step===0;
      back.textContent = step===N+1 ? '← Voltar ao resumo' : '← Voltar';
      var optionalAny = step<N && STEPS[step] && STEPS[step].type==='any' && STEPS[step].optional;
      skip.hidden = !optionalAny;
      if(optionalAny) skip.textContent = (step===N-1?'Pular e finalizar →':'Pular esta etapa →');
      // botão finalizar no fluxo (visível assim que o mínimo do kit é atingido)
      if(finishBtn){
        var ok=canFinish();
        finishBtn.hidden=!ok;
        if(ok) finishBtn.textContent=(data.button||'Adicionar ao carrinho')+' ('+Object.keys(sel).length+')';
      }
    }

    function renderCart(){
      var ks=Object.keys(sel), n=ks.length;
      if(!n){ cartItems.innerHTML='<p class="kit__empty">Você ainda não adicionou itens.</p>'; }
      else{
        cartItems.innerHTML='';
        ks.forEach(function(k){ var s=sel[k]; var li=el('div','kit__li');
          li.innerHTML='<img src="'+(s.image||'')+'"><div class="kit__li-t"><b>'+s.title+'</b><span>'+[s.color,s.size].filter(Boolean).join(' · ')+'</span></div><span class="kit__li-p">'+money(s.price)+'</span><button class="kit__li-x" title="Remover">&times;</button>';
          li.querySelector('.kit__li-x').addEventListener('click',function(){ delete sel[k]; renderCart(); renderProgress(); });
          cartItems.appendChild(li); });
      }
      var sub=subtotal(), pct=discPct(n), discAmt=Math.round(sub*pct/100), total=sub-discAmt, html='';
      if(n){
        if(discAmt>0){
          html+='<div class="kit__row"><span>Subtotal</span><span>'+money(sub)+'</span></div>';
          html+='<div class="kit__row kit__row--disc"><span>Desconto kit (-'+pct+'%)</span><span>-'+money(discAmt)+'</span></div>';
        }
        html+='<div class="kit__row kit__row--total"><span>Total</span><span class="kit__total-val">'+money(total)+'</span></div>';
        if(discAmt>0){
          if(AUTO){ html+='<p class="kit__note">*O desconto do kit não é cumulativo com outros cupons.</p>'; }
          else{ var cn=codeFor(n); if(cn&&COUPON_NOTE){ var chip='<button type="button" class="kit__copy" data-code="'+cn+'" title="Toque para copiar">'+cn+'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg></button>'; html+='<p class="kit__note kit__note--coupon">'+COUPON_NOTE.replace('[cupom]',chip)+'</p>'; } }
        }
      }
      cartTotals.innerHTML=html;
      // upsell próximo nível
      var up='';
      if(n>=1 && n<2 && D2>0) up='Adicione +1 item e ganhe '+D2+'% de desconto!';
      else if(n===2 && D3>D2) up='Adicione +1 item e ganhe '+D3+'% (em vez de '+D2+'%)!';
      else if(n===3 && D4>D3) up='Adicione +1 item e ganhe '+D4+'% (em vez de '+D3+'%)!';
      cartUpsell.hidden=true; // card verde de upsell desativado a pedido do dono (08/07)
      var miss=requiredMissing();
      var falta = miss.length ? null : (n<MIN ? (MIN-n) : 0); // quantos itens faltam pro mínimo
      if(miss.length){ cartHint.hidden=false; cartHint.textContent='Comece escolhendo '+miss.map(function(l){return 'uma '+l.toLowerCase();}).join(' e ')+'.'; addBtn.disabled=true; }
      else if(falta>0){ cartHint.hidden=false; cartHint.textContent='Adicione +'+falta+' produto'+(falta>1?'s':'')+' pra montar o kit (mínimo '+MIN+').'; addBtn.disabled=true; }
      else { cartHint.hidden=true; addBtn.disabled=false; }
      // barra fixa mobile
      if(barTotal){ barTotal.textContent = n? money(total) : 'R$ 0,00'; }
      if(barBtn){
        if(miss.length){ barBtn.disabled=true; barBtn.textContent='Escolha a sandália'; }
        else if(falta>0){ barBtn.disabled=true; barBtn.textContent='Adicione +'+falta+' pro kit'; }
        else { barBtn.disabled=false; barBtn.textContent=(data.button||'Finalizar kit')+' · '+n+(n>1?' itens':' item'); }
      }
      // sub-linha da barra: deixa CLARO que dá pra continuar adicionando
      if(barSub){
        barSub.classList.remove('kit__bar-sub--up');
        var upShort='';
        if(n>=1 && n<2 && D2>0) upShort='+1 item = '+D2+'% OFF';
        else if(n===2 && D3>D2) upShort='+1 item = '+D3+'% OFF';
        else if(n===3 && D4>D3) upShort='+1 item = '+D4+'% OFF';
        if(upShort){ barSub.textContent=upShort; barSub.classList.add('kit__bar-sub--up'); }
        else if(miss.length){ barSub.textContent='Comece pela sandália'; }
        else if(falta>0){ barSub.textContent='Mínimo '+MIN+' itens no kit'; }
        else { barSub.textContent='Pode adicionar mais itens'; }
      }
      if(typeof renderNav==='function') renderNav(); // atualiza o botão finalizar do fluxo
    }

    function render(){
      renderProgress(); renderNav(); renderCart(); stage.innerHTML='';
      if(step===N){ // resumo / done
        var d=el('div','kit__done');
        var miss=requiredMissing();
        d.appendChild(el('div','kit__done-ic','<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1.15"/><circle cx="19" cy="21" r="1.15"/><path d="M1.5 2.5h3l2.4 12.1a1.7 1.7 0 0 0 1.7 1.4h8.7a1.7 1.7 0 0 0 1.7-1.35L22.5 7H6"/></svg>'));
        d.appendChild(el('div','kit__done-t', miss.length?'Quase lá!':'Seu kit está montado!'));
        d.appendChild(el('div','kit__done-s', miss.length?('Falta escolher: '+miss.join(' e ')+'. Volte e escolha.'):(ALLOW_MORE?'Confira ao lado e finalize — ou adicione mais itens pra aumentar o desconto.':'Confira seu kit ao lado e finalize.')));
        if(ALLOW_MORE){ var b=el('button','kit__addmore','＋ '+ADDMORE); b.type='button'; b.addEventListener('click',function(){ extraOpened=true; goto(N+1); }); d.appendChild(b); }
        stage.appendChild(d);
        return;
      }
      if(step===N+1){ renderAnyBrowse('Adicionar mais itens', 'Escolha qualquer produto do site pra somar ao seu kit — o desconto continua valendo.'); return; }
      var st=STEPS[step];
      if(st.type==='any'){ renderAnyBrowse('Etapa '+(step+1)+' de '+N+' · '+st.label, CHOICE_INSTR, true); return; }
      // etapa fixa obrigatória
      var head=el('div','kit__stage-head');
      head.appendChild(el('div','kit__stage-kick','Etapa '+(step+1)+' de '+N));
      head.appendChild(el('div','kit__stage-t', st.cat.label+' <span class="kit__tag kit__tag--req">obrigatória</span>'));
      head.appendChild(el('div','kit__stage-opt', st.cat.instruction||'Escolha sua sandália pra começar o kit.'));
      stage.appendChild(head);
      var grid=el('div','kit__products'); stage.appendChild(grid);
      renderProducts(grid, st.cat.products, st.idx, true);
    }

    function renderAnyBrowse(kicker, instr, isGuided){
      var stp=isGuided?STEPS[step]:null;
      var optional=stp?stp.optional:true;
      var head=el('div','kit__stage-head');
      head.appendChild(el('div','kit__stage-kick', isGuided?('Etapa '+(step+1)+' de '+N):('Etapa '+(N+1))));
      // etapa "escolha qualquer produto": nunca rotular de "obrigatória" — o que é
      // obrigatório é ter um 2º item, de QUALQUER categoria (clientes achavam que a meia era)
      var tag = isGuided
        ? (optional?' <span class="kit__tag kit__tag--opt">opcional — pode pular</span>':' <span class="kit__tag kit__tag--opt">qualquer categoria</span>')
        : ' <span class="kit__tag kit__tag--opt">opcional</span>';
      var anyTitle = isGuided ? ('Escolha seu '+stp.num+'º item') : kicker;
      head.appendChild(el('div','kit__stage-t', anyTitle+tag));
      var subInstr = instr;
      if(isGuided){ subInstr = optional
        ? 'Etapa opcional — pule se quiser, ou adicione e aumente seu desconto.'
        : 'Pode ser de qualquer categoria — inclusive outra sandália. É esse item que fecha seu kit com desconto.'; }
      if(subInstr) head.appendChild(el('div','kit__stage-opt', subInstr));
      stage.appendChild(head);
      var catsEl=el('div','kit__cats');
      allCats.forEach(function(e,i){
        var b=el('button','kit__cat'+(i===anySel?' is-sel':''),e.cat.label); b.type='button';
        b.addEventListener('click',function(){ anySel=i; render(); });
        catsEl.appendChild(b);
      });
      stage.appendChild(catsEl);
      var grid=el('div','kit__products'); stage.appendChild(grid);
      var e=allCats[anySel];
      renderProducts(grid, e.cat.products, e.idx, true);
    }

    function renderProducts(grid, products, ci, advance){
      (products||[]).forEach(function(p){
        if(!p.available) return;
        var card=el('div','kit__prod');
        card.innerHTML='<div class="kit__prod-main"><img class="kit__prod-img" src="'+(p.image||'')+'" alt="" loading="lazy"><div class="kit__prod-info"><div class="kit__prod-t">'+p.title+'</div><div class="kit__prod-p">'+money(p.price)+'</div><div class="kit__cfg"></div></div></div>';
        card.querySelector('.kit__prod-main').addEventListener('click',function(ev){ if(ev.target.closest('.kit__cfg'))return; openCard(grid,card,p,ci,advance); });
        grid.appendChild(card);
      });
    }

    function openCard(grid,card,p,ci,advance){
      var was=card.classList.contains('is-open');
      grid.querySelectorAll('.kit__prod').forEach(function(c){c.classList.remove('is-open');});
      if(was)return; card.classList.add('is-open');
      var cfg=card.querySelector('.kit__cfg');
      if(cfg.dataset.loaded)return;
      cfg.innerHTML='<p style="color:#7d736b;font-size:13px;margin-top:10px">Carregando…</p>';
      get(p.handle).then(function(pr){ buildCfg(card,cfg,pr,ci,advance); cfg.dataset.loaded='1'; });
    }
    function get(h){ if(cache[h])return Promise.resolve(cache[h]); return fetch('/products/'+h+'.js').then(function(r){return r.json();}).then(function(j){cache[h]=j;return j;}); }
    function buildCfg(card,cfg,pr,ci,advance){
      var img=card.querySelector('.kit__prod-img');
      var onames=pr.options.map(function(o){ return ((o&&o.name)||o||'').toString(); });
      var cidx=-1,zi=-1;
      onames.forEach(function(nm,i){ var n=nm.toLowerCase();
        var isColor=n.indexOf('cor')>=0||n.indexOf('color')>=0;
        var isSize=n.indexOf('tam')>=0||n.indexOf('size')>=0||n.indexOf('num')>=0;
        if(isColor){ if(cidx<0)cidx=i; }
        else if(isSize){ if(zi<0&&i!==cidx)zi=i; }
      });
      var colors=[],sizes=[];
      if(cidx>=0)pr.variants.forEach(function(v){ var nm=v.options[cidx]; if(!colors.some(function(c){return c.name===nm;}))colors.push({name:nm,image:(v.featured_image&&v.featured_image.src)||pr.featured_image}); });
      if(zi>=0)pr.variants.forEach(function(v){ var s=v.options[zi]; if(sizes.indexOf(s)<0)sizes.push(s); });
      var st={color:colors[0]?colors[0].name:null,size:null};
      var h=''; if(cidx>=0)h+='<div class="kit__opt-label">'+(onames[cidx]||'Cor')+'</div><div class="kit__sws"></div>'; if(zi>=0)h+='<div class="kit__opt-label">'+(onames[zi]||'Tamanho')+'</div><div class="kit__sizes"></div>';
      h+='<button class="kit__addstep" type="button" disabled>Adicionar e continuar →</button>'; cfg.innerHTML=h;
      var add=cfg.querySelector('.kit__addstep');
      function ready(){ add.disabled=!((cidx<0||st.color)&&(zi<0||st.size)); }
      if(cidx>=0){ var sws=cfg.querySelector('.kit__sws'); colors.forEach(function(c,idx){ var b=el('button','kit__sw'+(idx===0?' is-sel':'')); b.type='button'; if(c.image){ b.classList.add('kit__sw--img'); var sim=document.createElement('img'); sim.src=c.image+(c.image.indexOf('?')>-1?'&':'?')+'width=120'; sim.alt=c.name; b.appendChild(sim); } else { b.style.background=hex(c.name); } b.title=c.name; b.addEventListener('click',function(){ sws.querySelectorAll('.kit__sw').forEach(function(x){x.classList.remove('is-sel');}); b.classList.add('is-sel'); st.color=c.name; if(c.image)img.src=c.image; ready(); }); sws.appendChild(b); }); if(colors[0]&&colors[0].image)img.src=colors[0].image; }
      if(zi>=0){ var szs=cfg.querySelector('.kit__sizes'); sizes.forEach(function(s){ var b=el('button','kit__size',s); b.type='button'; b.addEventListener('click',function(){ szs.querySelectorAll('.kit__size').forEach(function(x){x.classList.remove('is-sel');}); b.classList.add('is-sel'); st.size=s; ready(); }); szs.appendChild(b); }); }
      ready();
      add.addEventListener('click',function(){
        if(add.disabled)return;
        var v=pr.variants.filter(function(v){ var ok=true; if(cidx>=0)ok=ok&&v.options[cidx]===st.color; if(zi>=0)ok=ok&&v.options[zi]===st.size; return ok; })[0];
        if(!v){ alert('Combinação indisponível.'); return; }
        sel['k'+(uid++)]={id:v.id,title:pr.title,color:st.color,size:st.size,price:v.price,image:(v.featured_image&&v.featured_image.src)||pr.featured_image,cat:ci};
        renderCart(); add.textContent='Adicionado ✓'; add.disabled=true;
        if(advance){ setTimeout(function(){ goto(step>=N? N : step+1); }, 560); }
      });
    }

    // discount_code aceita lista "COD2,COD3,COD4" — escolhida pelo nº de itens (2→1º, 3→2º, 4+→último)
    function codeFor(n){
      if(!CODE) return '';
      var codes=CODE.split(',').map(function(c){return c.trim();}).filter(Boolean);
      if(codes.length<=1) return codes[0]||'';
      if(n<2) return '';
      return codes[Math.min(n-2,codes.length-1)];
    }
    function addToCart(){
      var items=Object.keys(sel).map(function(k){return {id:sel[k].id,quantity:1};});
      if(!items.length)return; addBtn.disabled=true; var t=addBtn.textContent; addBtn.textContent='Adicionando…';
      var code=codeFor(items.length);
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
        .then(function(r){return r.json();}).then(function(){
          // aplica o cupom via cookie (sem navegar) e abre o carrinho deslizante
          var openCart=function(){
            addBtn.disabled=false; addBtn.textContent=t;
            var icon=document.getElementById('cart-icon-bubble');
            var drawer=document.querySelector('cart-drawer');
            if(icon){ icon.click(); }
            else if(drawer&&typeof drawer.open==='function'){ drawer.open(); }
            else{ window.location.href='/cart'; }
          };
          if(code&&AUTO){ try{localStorage.setItem('pa-kit-code',code);}catch(e){} fetch('/discount/'+encodeURIComponent(code)).then(openCart,openCart); }
          else{ openCart(); }
        })
        .catch(function(){ addBtn.disabled=false; addBtn.textContent=t; alert('Erro ao adicionar ao carrinho.'); });
    }

    render();
  }
  document.querySelectorAll('.kit').forEach(init);
})();
